This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="basicBlock">
    <p class="subheader top">{{ $t("game.variables") }}</p>
    <div
      v-for="(value, name, index) in mockVariable.env"
      :key="index"
      class="blockEntry"
    >
      <b>{{ value.name }}: </b><i>{{ value.type }}, </i>{{ value.value }}
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      mockVariable: {
        type: "idk",
        id: "1",
        env: [
          { name: "Richting", value: "Noord", type: "opties" },
          { name: "Vakje", value: "Gele ster", type: "opties" },
          { name: "RobbieBlij", value: "Waar", type: "bool" },
          { name: "Graskleur", value: "Groen", type: "tekst" },
        ],
      },
    };
  },
})
export default class VariableBlock extends Vue {}
</script>
